import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/services/api";

export const fatchProduct = createAsyncThunk(
  "product/fatchProduct",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.get("admin/products?type=" + data.activetab + "&page=" + data.page + "&perPage=" + data.perPage + "&main_category_id=" + data.maincategory + "&category_id=" + data.category + "&sub_category_id=" + data.subcategory + "&search=" + data.search + "&currency_id=" + data.currencyCode);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to load products");
    }
  }
);

export const acceptProduct = createAsyncThunk(
  "product/acceptProduct",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post("admin/products/approve-or-reject", { product_id: data.id, [data.key]: data.value });
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to load products");
    }
  }
);

export const addProduct = createAsyncThunk(
  "product/addProduct",
  async (data, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      Object.keys(data).forEach((key) => {
        let value = data[key];

        if (key === "product_variants" || key === "product_attributes" || key === 'available_vendors' || key === 'installation_charge') {
          formData.append(key, JSON.stringify(value));
        }
        else if (key === "color_attributes") {
          value.forEach((color_attribute, i) => {
            if (color_attribute.image instanceof File) {
              formData.append(`color_attributes[${i}][color_attribute_id]`, color_attribute.color_attribute_id);
              formData.append(`color_attributes[${i}][size_attribute_id]`, color_attribute.size_attribute_id);
              formData.append(`color_attributes[${i}][image]`, color_attribute.image);
            }
          });
        }
        else {
          formData.append(key, value);
        }
      });
      formData.append('is_web', true);

      let url = data?.id ? `/update/${data.id}` : "";
      const response = await api.post("admin/products" + url, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to add product");
    }
  }
);

export const AddProductAvailableVendor = createAsyncThunk(
  "product/AddProductAvailableVendor",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post("admin/products/add-available-vendors", data);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to add available vendor");
    }
  }
);

export const bulkActionUpdate = createAsyncThunk(
  "product/bulkActionUpdate",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post("admin/products/bulk-update", data);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to perform action");
    }
  }
);

export const deleteProduct = createAsyncThunk(
  "product/deleteProduct",
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.del("admin/products/" + id);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to load products");
    }
  }
);

export const deleteProductImage = createAsyncThunk(
  "product/deleteProductImage",
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.post("admin/products/remove-image?id=" + id);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to load products");
    }
  }
);

export const fetchMainCategories = createAsyncThunk(
  "product/fetchMainCategories",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`admin/categories`);
      const data = response.data.map(row => ({ value: row.id, label: row.name }));
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to load products");
    }
  }
);
export const fetchCategories = createAsyncThunk(
  "product/fetchCategories",
  async (parent_id = 0, { rejectWithValue }) => {
    try {
      const response = await api.get(`admin/categories?parent_id=${parent_id}`);
      const data = response.data.map(row => ({ value: row.id, label: row.name }));
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to load products");
    }
  }
);
export const fetchSubCategories = createAsyncThunk(
  "product/fetchSubCategories",
  async (parent_id = 0, { rejectWithValue }) => {
    try {
      const response = await api.get(`admin/categories?parent_id=${parent_id}`);
      const data = response.data.map(row => ({ value: row.id, label: row.name }));
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to load products");
    }
  }
);

export const fetchVendor = createAsyncThunk(
  "product/fetchVendor",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`admin/vendors`);
      const data = response.data.map(row => ({ value: row.id, label: row.first_name + " " + row.last_name + " " + `(${row.company_name})` }));
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to load vendor");
    }
  }
);

export const fetchBrand = createAsyncThunk(
  "product/fetchBrand",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`admin/fetch-brands`);
      const data = response.data.map(row => ({ value: row.id, label: row.name }));
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to load brand");
    }
  }
);

export const fetchColorAttribute = createAsyncThunk(
  "product/fetchColorAttribute",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`admin/get-size-color?type=color`);
      const data = response.data.map(row => ({ value: row.id, label: row.value, color_code: row.code }));
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to load color attribute");
    }
  }
);

export const fetchSizeAttribute = createAsyncThunk(
  "product/fetchSizeAttribute",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`admin/get-size-color?type=size`);
      const data = response.data.map(row => ({ value: row.id, label: row.value }));
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to load size attribute");
    }
  }
);

export const fetchProductAttribute = createAsyncThunk(
  "product/fetchProductAttribute",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`admin/attributes`);
      const data = response.data.map(row => ({ value: row.id, label: row.name }));
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to load product attribute");
    }
  }
);

export const fetchProductAttributeValue = createAsyncThunk(
  "product/fetchProductAttributeValue",
  async (formdata, { rejectWithValue }) => {
    try {
      const response = await api.get(`admin/attribute-values?attribute_id=${formdata.attribute_id}`);
      const data = response.data.map(row => ({ value: row.id, label: row.value }));
      return { data: data, index: formdata.index };
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to load product attribute");
    }
  }
);

export const fetchProductVarient = createAsyncThunk(
  "product/fetchProductVarient",
  async (product_id, { rejectWithValue }) => {
    try {
      const response = await api.get(`admin/product-varient?product_id=${product_id}`);
      const data = response.data.map(row => ({
        value: row.id,
        label: "Color :  " + row?.color + ", Size : " + row?.size + ", Purchase Price : " + row.base_price + ", Sale Price : " + row.sale_price,
        currency_code: row?.currency_code
      }));
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to fatch product varient");
    }
  }
);

export const AddProductColorAttribute = createAsyncThunk(
  "product/AddProductColorAttribute",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(`admin/add-product-color-attribute`, data);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to add product attribute");
    }
  }
);

// export const uploadProducts = createAsyncThunk(
//   "product/uploadProducts",
//   async (data, { rejectWithValue }) => {
//     try {
//       const response = await api.post("admin/products/bulk-upload", data, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });
//       return response;
//     } catch (err) {
//       return rejectWithValue(err.response?.data || "Failed to upload products");
//     }
//   }
// );

export const uploadProducts = createAsyncThunk(
  "product/uploadProducts",
  async (data, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("product_csv", data.product_csv);
      formData.append("product_images", data.product_images);

      const response = await api.post("admin/products/bulk-upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to upload products");
    }
  }
);

export const downloadProductCSVFormat = createAsyncThunk(
  "product/downloadProductCSVFormat",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`admin/products-get-csv-url`);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to download.");
    }
  }
);

export const fetchCity = createAsyncThunk(
  "product/fetchCity",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.get(`admin/get-cities?country_id=` + formData?.country_id);
      const data = response.data.map(row => ({ value: row.id, label: row.name }));
      return { index: formData.index, data: data };
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to load city");
    }
  }
);


const productSlice = createSlice({
  name: "product",
  initialState: {
    list_products: [],
    main_categories: [],
    categories: [],
    sub_categories: [],
    vendors: [],
    brands: [],
    product_attributs: [],
    product_attribute_values: [],
    product_size_attributs: [],
    product_color_attributs: [],
    product_varients: [],
    selected: null,
    status: 'idle',
    loading: false,
    list_loading: false,
    error: null,
    totalElements: 0,
    totalPages: 0,
    currentPage: 0,
    cities: []
  },
  reducers: {
    setProduct(state, action) {
      state.list_products = action.payload;
    },
    setSelectedProduct(state, action) {
      const payload = action.payload || {};
      state.selected = {
        id: payload.id,
        sku_number: payload.sku_number,
        name: payload.name,
        main_category_id: payload.main_category_id,
        sub_category_id: payload.sub_category_id,
        category_id: payload.category_id,
        brand_id: payload.brand_id,
        installation_charge:
          payload.installation_charges?.reduce((acc, charge) => {
            const currencyCode = charge?.currency?.currency_code;

            if (currencyCode) {
              acc[currencyCode] = charge?.amount ?? "";
            }

            return acc;
          }, {}) || {},
        vat_tax: payload.vat_tax,
        is_featured: payload.is_featured,
        status: payload.status,
        short_description: payload.short_description,
        description: payload.description,
        product_variants: payload.varients,
        product_attributes: payload.specifications,
        color_attributes: payload.colors,
        available_vendors: payload.available_vendors?.length ? payload.available_vendors : [{ id: "", country_id: "", city_id: "", vendor_ids: [], price: "", currency_code: "", product_varient_id: "" }]
      };
    },
    resetStatus(state) {
      state.status = "idle";
      state.loading = false;
      state.list_loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addProduct.pending, (state) => {
        state.loading = true;
      })
      .addCase(addProduct.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(addProduct.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(fetchMainCategories.fulfilled, (state, action) => {
        state.main_categories = action.payload;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.categories = action.payload;
      })
      .addCase(fetchSubCategories.fulfilled, (state, action) => {
        state.sub_categories = action.payload;
      })
      .addCase(fetchVendor.fulfilled, (state, action) => {
        state.vendors = action.payload;
      })
      .addCase(fetchBrand.fulfilled, (state, action) => {
        state.brands = action.payload;
      })
      .addCase(fetchColorAttribute.fulfilled, (state, action) => {
        state.product_color_attributs = action.payload;
      })
      .addCase(fetchSizeAttribute.fulfilled, (state, action) => {
        state.product_size_attributs = action.payload;
      })
      .addCase(fetchProductAttribute.fulfilled, (state, action) => {
        state.product_attributs = action.payload;
      })
      .addCase(fetchProductAttributeValue.fulfilled, (state, action) => {
        const { index, data } = action.payload;

        if (!state.product_attribute_values) state.product_attribute_values = [];

        while (state.product_attribute_values.length <= index) {
          state.product_attribute_values.push([]);
        }

        state.product_attribute_values[index] = data || [];
      })
      .addCase(fetchCity.fulfilled, (state, action) => {
        const { index, data } = action.payload;

        if (!state.cities) state.cities = [];

        while (state.cities.length <= index) {
          state.cities.push([]);
        }

        state.cities[index] = data || [];
      })
      .addCase(fatchProduct.pending, (state) => {
        state.list_loading = true;
        state.error = null;
      })
      .addCase(fatchProduct.fulfilled, (state, action) => {
        state.list_loading = false;
        state.list_products = action.payload;
      })
      .addCase(fatchProduct.rejected, (state, action) => {
        state.list_loading = false;
        state.error = action.payload;
      })
      .addCase(deleteProduct.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteProduct.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteProduct.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteProductImage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteProductImage.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteProductImage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(acceptProduct.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(acceptProduct.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(acceptProduct.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(AddProductColorAttribute.pending, (state) => {
        state.loading = true;
      })
      .addCase(AddProductColorAttribute.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(AddProductColorAttribute.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(bulkActionUpdate.pending, (state) => {
        state.loading = true;
      })
      .addCase(bulkActionUpdate.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(bulkActionUpdate.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(uploadProducts.pending, (state) => {
        state.loading = true;
      })
      .addCase(uploadProducts.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(uploadProducts.rejected, (state) => {
        state.loading = false;
      })
      .addCase(downloadProductCSVFormat.pending, (state) => {
        state.loading = true;
      })
      .addCase(downloadProductCSVFormat.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(downloadProductCSVFormat.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchProductVarient.fulfilled, (state, action) => {
        state.product_varients = action.payload;
      });
  }
});

export const { setProduct, setSelectedProduct, resetStatus } = productSlice.actions;
export default productSlice.reducer;
